<app-page>
	<section class="section-padding section-wall-bg">
		<div class="container">
			<div class="row">
				<div class="col-lg-10 offset-lg-1 text-center">
					<h1 class="section-title-big" translate>
						Comfortable and energy-efficient heating with SeltronHome
					</h1>
				</div>
				<div class="col-md-6 section-info-big">
					<p translate class="text-center text-lg-left">
						GWD communication module connects your Seltron controller to the
						Internet.
					</p>
					<p translate class="text-center text-lg-left">
						Manage your heating system anytime and anywhere you are with an
						intuitive mobile and web app Clausius.
					</p>
					<div class="row row-button-group">
						<div
							class="col-10 offset-1 col-sm-8 offset-sm-2 col-lg-6 offset-lg-0"
						>
							<app-btn-call-to-action
								[routerLink]="getRouterLink(ROUTE_PATH.APPLICATION)"
								size="md"
								[fullWidth]="true"
							>
								<span translate>Learn more</span>
							</app-btn-call-to-action>
						</div>
					</div>
				</div>
				<div class="d-none d-md-block col-6 text-center">
					<img
						class="img-fluid"
						src="assets/img/Vstopna/gwd-new.png"
						alt="GWD"
					/>
				</div>
			</div>
		</div>
	</section>

	<section class="section-padding">
		<div class="container">
			<div class="row">
				<div class="col-md-6">
					<h1 class="section-title" translate>Comfortable saving</h1>
					<p class="section-info" translate>
						Weather compensated Seltron heating, boiler and solar controllers
						are renowned for their energy efficiency.
					</p>
					<p class="section-info" translate>
						By connecting your Seltron controller to the SeltronHome platform
						you get even more flexibility, simplicity and comfort while cutting
						down on heating costs.
					</p>
				</div>

				<div class="col-md-6 text-center">
					<img
						class="img-fluid"
						src="assets/img/Vstopna/privarcuj.jpg"
						alt="Save money"
					/>
				</div>
			</div>
		</div>
	</section>

	<section class="section-padding">
		<div class="container">
			<div class="row flex-wrap-reverse flex-lg-wrap">
				<div class="col-md-6 text-center">
					<img
						class="img-fluid"
						src="assets/img/Vstopna/prilagojen.jpg"
						alt="Adapted to you"
					/>
				</div>
				<div class="col-md-6">
					<h1 class="section-title" translate>Tailored to you</h1>
					<p class="section-info pb-2" translate>
						Clausius is designed to harness the flexibility in versatility of
						your Seltron controller in an intuitive application.
					</p>
					<p class="section-info" translate>
						It takes virtually zero effort to heat your home to just the right
						temperature at the right time.
					</p>
				</div>
			</div>
		</div>
	</section>

	<section class="section-padding">
		<div class="container">
			<div class="row">
				<div class="col-md-6">
					<h1 class="section-title" translate>Always at your fingertips</h1>
					<p class="section-info pb-2" translate>
						Unlike your heating system, your mobile phone goes where you go.
						Clausius makes it possible for you to be in touch with your heating
						system anytime, anywhere.
					</p>
					<p class="section-info" translate>
						Never miss anything important about your heating system. Clausius
						even notifies you before your boiler runs out of pellets or wood so
						you're never going to be left in cold.
					</p>
				</div>

				<div class="col-md-6 text-center">
					<img
						class="img-fluid"
						src="assets/img/Vstopna/priroki.jpg"
						alt="At hand"
					/>
				</div>
			</div>
		</div>
	</section>

	<section class="section-padding">
		<div class="container">
			<div class="row flex-wrap-reverse flex-lg-wrap">
				<div class="col-md-6 text-center">
					<img
						class="img-fluid"
						src="assets/img/Vstopna/podpora.jpg"
						alt="Support"
					/>
				</div>

				<div class="col-md-6">
					<h1 class="section-title" translate>Effective remote support</h1>
					<p class="section-info pb-2" translate>
						Ask your heating system maintainer if they already use the °Kelvin
						app. With the °Kelvin app a maintainer can be notified about
						possible issue in operation and can quickly resolve or diagnose the
						root of the issue.
					</p>
					<p class="section-info" translate>
						The best of all is that they can be prepared prior to their service
						visit. This means less maintainer visits and faster resolved issues.
					</p>
				</div>
			</div>
		</div>
	</section>

	<section class="section-padding">
		<div class="container">
			<div class="row">
				<div class="col-lg-10 offset-lg-1 text-center">
					<h1 class="section-title-big" translate>
						Mobile and web application Clausius
					</h1>
				</div>
				<div class="col-md-6">
					<p class="section-info pb-3 text-center text-lg-left" translate>
						Clausius is available for devices running Android and iOS operating
						systems.
					</p>
					<p class="section-info pb-3 text-center text-lg-left">
						<span translate
							>You can also use Clausius in your preferred mobile or desktop web
							browser by visiting the link</span
						>
						<a
							class="d-inline-block ml-1"
							[externalRedirect]="EXTERNAL_PATH.CLAUSIUS_SELTRONHOME"
							>clausius.seltronhome.com</a
						>.
					</p>
					<p class="section-info text-center text-lg-left" translate>
						Download Clausius and take it for a test ride:
					</p>
					<div class="row">
						<div
							class="col-12 d-flex justify-content-center justify-content-lg-start mb-5"
						>
							<button type="button" class="btn btn-google-play p-0">
								<img
									[externalRedirect]="EXTERNAL_PATH.APP_GOOGLE_PLAY"
									class="img-fluid"
									src="assets/img/google-play.png"
									alt="GooglePlay"
								/>
							</button>
							<button type="button" class="btn btn-app-store p-0">
								<img
									[externalRedirect]="EXTERNAL_PATH.APP_APPLE_STORE"
									class="img-fluid"
									src="assets/img/appstore.png"
									alt="AppStore"
								/>
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-6 text-center">
					<img
						class="img-fluid"
						src="assets/img/Vstopna/apps-vstopna-1.png"
						alt="Multiple devices"
					/>
				</div>
			</div>
		</div>
	</section>

	<section class="section-padding section-navigation-bg">
		<div class="container">
			<div class="row">
				<div class="col-md-8 offset-md-2 text-center">
					<app-btn-call-to-action
						[routerLink]="getRouterLink(ROUTE_PATH.APPLICATION)"
						size="lg"
						color="green"
					>
						<span translate>Learn more about Clausius features</span>
					</app-btn-call-to-action>
				</div>
			</div>
		</div>
	</section>
</app-page>
